import { action, computed, observable, runInAction } from "mobx";
import { api } from "../../api";
import { IEmpresa, IFilter, newEmpresa } from "../../model";
import { toast } from "react-toastify";
import { decodeUtf8String, downloadBinaryFile, nameFile, sortBy } from "../../utils";
import { v4 as uuidv4 } from 'uuid';
import { TarefasStore } from "../notas/TarefasStore";

export class _NFesStore {
  obs = observable({
    imps: [] as any[],
    cnpj_selected: "" as string,
    progressDownload: false as boolean,
    empresas: [] as IEmpresa[],
    download_danfe_ok: false as boolean,

    selectedTab: "notas" as string,

    selectedEmpresa: newEmpresa() as IEmpresa,
    tasks_relatorio: [],
    length_tasks_relatorio:  0,
  })

  @action
  async loadEmpresas(): Promise<void> {
    try {
      let resp = await api.get(`/api/empresas-usuario`);
      this.obs.empresas = [];
      this.obs.empresas = resp.data
    } catch (ex) {
      toast.error("Erro ao carregar Empresas Usuário, tente novamente mais tarde.", {});
    }
  }

  @computed
  get sortedEmpresas(): IEmpresa[] {
    return sortBy(this.obs.empresas, "razao_social");
  }

  async setBusca(
    empresa: any,
    tipo: string,
    filtro: string,
    date1: string,
    date2: string,
  ): Promise<void> {
    this.obs.cnpj_selected = empresa;

    let params = {
      empresa: empresa,
      filtro: filtro,
      tipo: tipo,
      data1: date1,
      data2: date2
    }
    try {

      let resp = await api.post(`/api/xml-busca`, params)

      if (resp.data == "Conta não Encontrado") {
        toast.warning('Não foram encontrados resultados.', {});

      } else {
        this.obs.imps = [];

        if (resp.data.xmls.length > 0) {

          this.obs.imps = resp.data.xmls?.map((obj) => {
            obj.tipo = tipo;
            // let chaves = obj.map(item => item.chave);
            // console.log(chaves)
            return obj
          });

        } else {
          toast.warning('Não foram encontrados resultados.', {});
        }
      }

    } catch (e) { return e; }
  }

  async download_xml(documento: any, razao_social: string) {

    try {

      let resp = await api.post("/api/xml-download", documento, { responseType: 'blob' });

      if (resp.status == 200) {

        const name = this.nameFile(documento, razao_social, "")

        downloadBinaryFile(resp.data, name)

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast.error("Erro ao realizar download xmls, tente novamente mais tarde.", {});

    }

  }

  async download_eventos(documento: any, razao_social: string) {

    try {

      let resp = await api.post("/api/xml-download-evento", documento, { responseType: 'blob' });

      if (resp.status == 200) {

        const name = this.nameFile(documento, razao_social, "-Eventos")

        downloadBinaryFile(resp.data, name)

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast.error("Erro ao realizar download xmls, tente novamente mais tarde.", {});

    }

  }

  async view_danfe(empresa: IEmpresa, data: any) {

    try {

      let resp = await api.post("/api/danfe-download", data);

      if (resp.status == 200 && data.tipo === "NFS-E") {

        toast.success("Solicitação de DANFSe realizada com sucesso!", {});

        await TarefasStore.handleTasksPaged(1)

        NFesStore.obs.selectedTab = "tarefas"

      } else if (resp.status == 200) {

        let linkSource = `data:application/pdf;base64,${resp.data.base64}`
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = nameFile(empresa, `${data.data1}_${data.data2}`);
        downloadLink.click();

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast.error(`Erro ao realizar Download Danfe, tente novamente mais tarde.`, {});

    }

  }

  async download_danfe(documento: any, razao_social: string): Promise<void> {

    try {

      let resp = await api.post("/api/danfe-download", documento, { responseType: 'blob' });

      if (resp.status === 200 && documento.tipo === "NFS-E") {

        toast.success("Solicitação de DANFSe realizada com sucesso!", {});

        await TarefasStore.handleTasksPaged(1)
        
        NFesStore.obs.selectedTab = "tarefas"

      } else if (resp.status === 200) {

        const name = this.nameFile(documento, razao_social, "-PDF");

        downloadBinaryFile(resp.data, name);

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast.error(`Erro ao realizar Download Danfe, tente novamente mais tarde.`, {});

    }

  }

  async cancelar_nota(cnpj: string, dhemi: number, chave: string, tipo: string, filtro: string, uf: string) {

    try {

      let data = {
        cnpj: cnpj,
        dhemi: dhemi,
        chave: chave,
        modelo: tipo,
        tipo: filtro,
        uf: uf
      }

      console.log(data)

      let resp = await api.post("/api/xml-cancelar-nota", data);

      if (resp.data.ok) {

        toast.success('Solicitação de cancelamento realizada com sucesso!', {});

      } else {

        toast.error('Erro ao solicitar cancelamento, tente novamente mais tarde.', {});

      } 
      
    } catch (error) {
      
      toast.error('Erro ao cancelar nota, tente novamente mais tarde.', {});

    }

  }

  formatDate(data) {

    const splited = data.split("-").reverse().join("-")

    return splited

  }

  nameFile(documento, empresa, modelo) {

    const razao_social = empresa.replace(/\ /g, "_")
    const cnpj = documento["empresa"]
    const date1 = this.formatDate(documento["data1"])
    const date2 = this.formatDate(documento["data2"])

    const entrada_saida = documento["filtro"].replace("í", "i").toUpperCase()

    const tipo = documento["tipo"].replace("-", "").toUpperCase()

    return `${razao_social}-${cnpj}-${date1}-${date2}-${tipo}-${entrada_saida}${modelo}.zip`

  }

  async handleIndexTask(page: number, cnpj: string, tipo: string, modelo: string) {

    try {

      let data = {
        paged: page,
        limit: 15,
        cnpj: cnpj == "" ? null : cnpj,
        tipo: tipo == "" ? null : tipo,
        modelo: modelo == "" ? null : modelo
      };

      let resp = await api.post("/api/xml-notas-index", data);

      this.obs.tasks_relatorio = [];
      this.obs.length_tasks_relatorio = 0;

      if (resp.data.itens.length > 0) {
        this.obs.tasks_relatorio = resp.data.itens;
        this.obs.length_tasks_relatorio = resp.data.count;
      }

    } catch (ex) {
      toast.error("Erro ao consultar importação tasks, tente novamente mais tarde.", {});
    }

  }

  async handleExport(params: any) {

    try {

      let resp = await api.post(`/api/xml-notas-export`, params)

      if (resp.data.ok) {

        toast.success('Relatório solicitado com sucesso', {});
        return true;

      }

    } catch (e) {}

    toast.error("Erro ao solicitar Relatório, tente novamente mais tarde.", {});
    return false;

  }

  async handleDownloadArquivoRelatorio(id: string, cnpj: string, format: string) {

    try {

      let resp = await api.post(`/api/relatorio/task/download`, {id: id, format: format}, { responseType: 'blob' });

      if(resp.status == 200){

        const fileName = cnpj + "_relatorio." + format;

        downloadBinaryFile(resp.data, fileName)

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast.error('erro ao baixar o arquivo, tente novamente mais tarde ou contate o suporte.', {});

    }

  }

}

export const NFesStore = new _NFesStore();
